import { legacyColors } from '~/legacyTheme';

export const useSxStyles = () => {
  return {
    root: {
      display: 'flex',
      columnGap: '10px',
      height: '50px',
      alignItems: 'center',
    },
    item: {
      color: legacyColors.blue,
      boxShadow: `0 6px 12px ${legacyColors.grey5}`,
      border: `1px solid ${legacyColors.grey3}`,
      width: '42px',
      height: '42px',
      borderRadius: '4px',
      fontSize: '30px',
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      '& svg': {
        fill: legacyColors.blue,
      },
      '&.disabled svg': {
        fill: legacyColors.grey5,
      },
      '&.disabled': {
        backgroundColor: legacyColors.grey2,
        color: legacyColors.grey5,
      },
      '&.active svg': {
        fill: legacyColors.white,
      },
      '&.active': {
        backgroundColor: legacyColors.blue,
        color: legacyColors.white,
      },
    },
  };
};
